import { AnnouncementDetailPage } from '@/components/announcements/announcement-detail-page'

export function OperationsAnnouncementDetail() {
  return <AnnouncementDetailPage basePath="/operations/announcements" />
}
